
    import { defineComponent } from 'vue';

    import { endpointSectionsComposition } from '../services'

    export default defineComponent({
        setup() {
            return { ...endpointSectionsComposition() }
        }
    })
